import React from 'react';
import clsx from 'clsx';

export default function Container({ children, className, id }) {
  return (
    <div id={id} className={clsx("max-w-6xl mx-auto px-4 sm:px-6 lg:px-8", className)}>
      {children}
    </div>
  );
}